import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as vacancyEffects from './vacancy.effects';
import * as vacancyTrackingEffects from './vacancy-tracking.effects';
import * as vacancyStore from './vacancy.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(vacancyStore.featureKey, vacancyStore.reducer),
    EffectsModule.forFeature([
      vacancyEffects.VacancyEffects,
      vacancyTrackingEffects.VacancyTrackingEffects,
    ]),
  ],
})
export class VacancyStateModule {}
